const swDev = () => {

    let swUrl= `${process.env.PUBLIC_URL}/sw.js`
  return (

    navigator.serviceWorker.register(swUrl)
  )
}

export default swDev